export default "__VITE_ASSET__DzZI2Eri__"